import React, { useState } from "react";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import { TraBotGoc } from "./TraBotGoc";

export const BtnTraBotGoc = ({ item }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <a onClick={handleShow} href={() => false}>
        <PopoversBootrap
          contentText="Trả bớt gốc"
          titleText=""
          trigger={["hover", "focus"]}
          placement={"top"}
        >
          <img src="/app-assets/images/icon-tra-bot-goc-v2.png" />
        </PopoversBootrap>
      </a>
      {show && (
        <TraBotGoc
          show={show}
          onHide={handleClose}
          NhanVayId={item.ID}
          TenChuNo={item.TenChuNo}
          item={item}
        />
      )}
    </>
  );
};
